/**
 * @Description
 */
export default {
  meta: {
    title: '首页'
  }
};
